import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-image-icon',
  templateUrl: './design-image.component.html'
})
export class DesignImageComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
